import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";
import Loader from "../../../../Common/Loader/loader";
import isGHMC, {
  formatDateTimeWithoutSec,
  formattedDate,
  getCurrentDateTime,
} from "../../../../Common/helper/helpar";
import { NoOfBinsFilter } from "./NoOfBinsFilter";
import { NoOfBinsInnerExport } from "./NoofBinsInnerExport";
import NoOfBinsGvpReportStore from "./store/NoOfBinsGvpReportStore";
import TableSkeleton from "../../../AllotedMaster/TableSkeleton";
export const NoOfBinsInnerReport = () => {
  const {
    noOfBinsGvpInnerData,
    noOfBinsGvpInnerDataLoading,
    fetchNoOfBinsGvpInnerReport,
    // fetchNoOfBinsGvpInnerData,
  } = NoOfBinsGvpReportStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { date, filters } = location.state || {};

  // Helper function to format date with start time (00:00:00)
  const formatDateWithStartTime = (dateString) => {
    if (!dateString) return "";
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) return dateString;

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00`;
  };

  const formatDateNewDate = (dateString) => {
    if (!dateString) return "";

    const [day, month, year] = dateString.split("-");

    if (!day || !month || !year) return dateString;

    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  // Helper function to get selected date with current time
  const getSelectedDateWithCurrentTime = (dateString) => {
    if (!dateString) return "";
    const selectedDate = new Date(dateString);
    if (isNaN(selectedDate.getTime())) return dateString;

    const now = new Date();
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const second = String(now.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
  };

  console.log("");
  const isallDates = localStorage.getItem("innerBinReportAllDates");
  useEffect(() => {
    // Use filter dates if available, otherwise use clicked date
    const startDate = formatDateNewDate(date);
    const endDate = formatDateNewDate(date);

    if (isallDates === "all") {
      fetchNoOfBinsGvpInnerReport({
        StartDate: filters.StartDate,
        EndDate: filters.EndDate,
      });
    } else {
      fetchNoOfBinsGvpInnerReport({ StartDate: startDate, EndDate: endDate });
    }

    // if (filters && filters.StartDate && filters.EndDate) {

    // } else if (date) {

    //   const startDate = formatDateWithStartTime(date);
    //   const endDate = getSelectedDateWithCurrentTime(date);
    //   fetchNoOfBinsGvpInnerReport({ StartDate: startDate, EndDate: endDate });
    // }
  }, [date, filters, fetchNoOfBinsGvpInnerReport]);
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  // Reset to first page when data changes
  useEffect(() => {
    setPage(0);
  }, [noOfBinsGvpInnerData]);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Helper function to format YYYYMMDD date string to DD-MM-YYYY
  const formatDateKey = (dateKey) => {
    if (!dateKey || dateKey.length !== 8) return dateKey;
    const year = dateKey.substring(0, 4);
    const month = dateKey.substring(4, 6);
    const day = dateKey.substring(6, 8);
    return `${day}-${month}-${year}`;
  };

  // Extract all date keys from data and sort them chronologically
  // Date keys are in YYYYMMDD format (e.g., 20260201 = February 1, 2026)
  const getDateKeys = () => {
    if (!noOfBinsGvpInnerData || noOfBinsGvpInnerData.length === 0) {
      return [];
    }
    const dateKeysSet = new Set();
    noOfBinsGvpInnerData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        // Check if key is a date (8 digits, numeric) - format: YYYYMMDD
        if (/^\d{8}$/.test(key)) {
          dateKeysSet.add(key);
        }
      });
    });
    // Sort dates chronologically (YYYYMMDD format sorts correctly as strings)
    return Array.from(dateKeysSet).sort();
  };

  const dateKeys = getDateKeys();

  // Filter out summary rows (RowType !== 0) and get only data rows
  const dataRows = noOfBinsGvpInnerData
    ? noOfBinsGvpInnerData.filter((row) => row.RowType === 0)
    : [];

  // Calculate percentage for each row (dates with value > 0 / total dates * 100)
  const calculateRowPercentage = (row) => {
    if (!dateKeys || dateKeys.length === 0) return 0;
    const datesWithValue = dateKeys.filter(
      (dateKey) => Number(row[dateKey] || 0) > 0,
    ).length;
    return Math.round((datesWithValue / dateKeys.length) * 100);
  };

  // Get paginated data
  const paginatedData = dataRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  // Calculate summary rows
  const calculateSummaryRows = () => {
    if (!dataRows || dataRows.length === 0) {
      return {
        overallGpvAttended: {},
        uniqueGpvAttended: {},
        performanceAchieved: {},
        totalUniqueGpvAttended: 0,
        totalPerformanceAchieved: 0,
      };
    }

    const overallGpvAttended = {};
    const uniqueGpvAttended = {};
    const performanceAchieved = {};

    const totalRows = dataRows.length;

    // ================= OVERALL (SUM) =================
    dateKeys.forEach((dateKey) => {
      overallGpvAttended[dateKey] = dataRows.reduce((sum, row) => {
        return sum + Number(row[dateKey] || 0);
      }, 0);
    });

    // ================= UNIQUE GPV =================
    dateKeys.forEach((dateKey) => {
      const zeroCount = dataRows.filter(
        (row) => Number(row[dateKey] || 0) === 0,
      ).length;

      const attendedCount = totalRows - zeroCount;

      uniqueGpvAttended[dateKey] = attendedCount;

      // ================= PERFORMANCE % =================
      performanceAchieved[dateKey] =
        totalRows > 0 ? ((attendedCount / totalRows) * 100).toFixed(2) : "0.00";
    });

    // ================= TOTAL UNIQUE =================
    let totalMissed = 0;

    dataRows.forEach((row) => {
      const attended = dateKeys.some(
        (dateKey) => Number(row[dateKey] || 0) > 0,
      );
      if (!attended) totalMissed++;
    });

    const totalUniqueGpvAttended = totalRows - totalMissed;

    // ================= TOTAL PERFORMANCE =================
    const totalPerformanceAchieved =
      totalRows > 0
        ? ((totalUniqueGpvAttended / totalRows) * 100).toFixed(2)
        : "0.00";

    return {
      overallGpvAttended,
      uniqueGpvAttended,
      performanceAchieved,
      totalUniqueGpvAttended,
      totalPerformanceAchieved,
    };
  };

  const summaryRows = calculateSummaryRows();

  // Styles
  const headerStyle = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "10px",
    color: "#fff",
    backgroundColor: isGHMC() ? "#0d5da5" : "#EC1117",
    fontWeight: 600,
    whiteSpace: "nowrap",
  };

  const cellStyle = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "8px",
  };

  const storedFilters = localStorage.getItem("noOfBinsGvpFilters");
  // const filters = JSON.parse(storedFilters);

  const currentDate = getCurrentDateTime();

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <NoOfBinsInnerExport
            data={noOfBinsGvpInnerData}
            date={date}
            fromDate={filters?.StartDate}
            toDate={filters?.EndDate}
          />

          {/* Data Table Section */}
          <div className="card mt-3">
            <div className="card-body">
              <div
                className="top-header p-2"
                style={{
                  backgroundColor: "#D7D7D7",
                  fontWeight: "600",
                  borderBottom: "1px solid #DDDDDD",
                }}
              >
                {isallDates === "all" ? (
                  <span>
                    Zone Wise Report ({filters?.StartDate} to {filters?.EndDate}
                    ) at {formatDateTimeWithoutSec(currentDate)}
                  </span>
                ) : (
                  <span>
                    Zone Wise Report ({date}) at{" "}
                    {formatDateTimeWithoutSec(currentDate)}
                  </span>
                )}
              </div>
              {/* Filter & Search Section */}

              {noOfBinsGvpInnerDataLoading ? (
                <TableSkeleton />
              ) : (
                <>
                  <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={headerStyle}>S.No</TableCell>
                          <TableCell sx={headerStyle}>Corporation</TableCell>
                          <TableCell sx={headerStyle}>Zone</TableCell>
                          <TableCell sx={headerStyle}>Circle Number</TableCell>
                          <TableCell sx={headerStyle}>Circle Name</TableCell>
                          <TableCell sx={headerStyle}>GVP Name</TableCell>
                          {dateKeys.map((dateKey) => (
                            <TableCell key={dateKey} sx={headerStyle}>
                              {formatDateKey(dateKey)}
                            </TableCell>
                          ))}
                          <TableCell sx={headerStyle}>
                            No.of Days Attended
                          </TableCell>
                          <TableCell sx={headerStyle}>%</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedData && paginatedData.length > 0 ? (
                          paginatedData.map((row, index) => (
                            <TableRow
                              key={page * rowsPerPage + index}
                              sx={{
                                backgroundColor: isGHMC()
                                  ? index % 2 === 0
                                    ? "#8fc9ff"
                                    : "#aed8ff"
                                  : index % 2 === 0
                                    ? "#F8CCCD"
                                    : "#ffeded",
                              }}
                            >
                              <TableCell sx={cellStyle}>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {row.CorporationName || "N/A"}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {row.ZoneName || "N/A"}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {row.CircleId || "N/A"}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {row.CircleName || "N/A"}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {row.GvpName || "N/A"}
                              </TableCell>
                              {dateKeys.map((dateKey) => (
                                <TableCell key={dateKey} sx={cellStyle}>
                                  {row[dateKey] || 0}
                                </TableCell>
                              ))}
                              <TableCell sx={cellStyle}>
                                {row.NoOfDaysAttended || "N/A"}
                              </TableCell>
                              <TableCell sx={cellStyle}>
                                {calculateRowPercentage(row)}%
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={6 + dateKeys.length + 1}
                              sx={{ ...cellStyle, textAlign: "center" }}
                            >
                              No data available
                            </TableCell>
                          </TableRow>
                        )}
                        {/* Summary Rows */}
                        {dataRows.length > 0 && (
                          <>
                            {/* Overall GPV Attended Row */}
                            <TableRow
                              sx={{
                                backgroundColor: isGHMC()
                                  ? "#0d5da5"
                                  : "#EC1117",
                                "& .MuiTableCell-root": {
                                  color: "#fff",
                                  fontWeight: 700,
                                },
                              }}
                            >
                              <TableCell sx={cellStyle}></TableCell>
                               <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}>
                                Overall GVP Attended
                              </TableCell>
                              {dateKeys.map((dateKey) => (
                                <TableCell key={dateKey} sx={cellStyle}>
                                  {summaryRows.overallGpvAttended[dateKey] || 0}
                                </TableCell>
                              ))}
                              <TableCell sx={cellStyle}>-</TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                            </TableRow>
                            {/* Unique GPV Attended Row */}
                            <TableRow
                              sx={{
                                backgroundColor: isGHMC()
                                  ? "#0d5da5"
                                  : "#EC1117",
                                "& .MuiTableCell-root": {
                                  color: "#fff",
                                  fontWeight: 700,
                                },
                              }}
                            >
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}>
                                Unique GVP Attended
                              </TableCell>
                              {dateKeys.map((dateKey) => (
                                <TableCell key={dateKey} sx={cellStyle}>
                                  {summaryRows.uniqueGpvAttended[dateKey] || 0}
                                </TableCell>
                              ))}
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}>-</TableCell>
                            </TableRow>
                            {/* Performance Achieved Row */}
                            <TableRow
                              sx={{
                                backgroundColor: isGHMC()
                                  ? "#0d5da5"
                                  : "#EC1117",
                                "& .MuiTableCell-root": {
                                  color: "#fff",
                                  fontWeight: 700,
                                },
                              }}
                            >
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}>
                                Performance Achieved
                              </TableCell>
                              {dateKeys.map((dateKey) => (
                                <TableCell key={dateKey} sx={cellStyle}>
                                  {summaryRows.performanceAchieved[dateKey] ||
                                    0}
                                  %
                                </TableCell>
                              ))}
                              <TableCell sx={cellStyle}></TableCell>
                              <TableCell sx={cellStyle}>-</TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={dataRows?.length || 0}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[100, 500, 1000, 2000]}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
